import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ForexTrading from "./../../../Images/forex-trading.png";
import "./FoxTraderWelcome.css";
import TrackApi from "../../Activity_Track/TrackApi";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
function FoxTraderWelcome() {
  const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Fox Trader Note",
      "mx_Custom_1": "Fox Trader",
      "mx_Custom_2": "Your  Fox Trader page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  })
  return (
    <>
      <section className="fox-trader-welcome">
        <Container>
          <Row>
            <Col md={7}>
              <div>
                <h3>Fox Trader</h3>
                <p>
                  The best way to capitalize on the future is to first
                  understand the past. "Moneysukh" has paved the way for smooth
                  trading by partnering with Reliable Software India Private
                  Ltd. to introduce its users to the Fox Trader trading
                  software. This next-generation stock trading software has a
                  smooth and friendly user- interface designed for automated or
                  one-touch trading processes, as well as nearly all of the
                  exceptional features expected from modern trading software. It
                  supports the NSE-CM, NSE-Cur, NSE-FO, BSE, and MCX markets.
                </p>
                <p>
                  Fox Trader runs multiple scanners with indicator-based
                  backtesting, allowing a trader to understand and analyze past
                  data with 200+ conditions/signals, 300+ studies, and other
                  methods.
                </p>
              </div>
            </Col>
            <Col md={5}>
              <div className="fox-trading-img">
                <img
                  className="img-fluid"
                  src={ForexTrading}
                  alt="ForexTrading"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default FoxTraderWelcome;
